// shell/CountBadge.tsx — unread count chip (rail nav items + topbar bell/messages).
//
// 1.25.00: was a 135deg magenta→violet gradient pill with a glow halo, on an
// 18px element where a gradient is physically indiscernible from a flat fill —
// three named generated-UI tells stacked on a chip too small to show any of
// them. Now a flat accent fill with onAccent digits: a count is data, and the
// only thing it has to do is read at a glance.

import styled from 'styled-components';

export const CountBadge = styled.span`
  display: inline-grid;
  place-items: center;
  box-sizing: border-box;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: ${({ theme }) => theme.radius.sm};
  background: ${({ theme }) => theme.color.accentCyan};
  /* onAccent is solved per accent, so digits stay legible on every preset and
     on a custom hex. A hardcoded white failed on the light theme's deep ink. */
  color: ${({ theme }) => theme.color.onAccent};
  font-family: ${({ theme }) => theme.font.mono};
  font-size: 10px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  line-height: 1;
`;
